// extracted by css-extract-rspack-plugin
export default {"checkbox":"jU_9Lh09l_Ecfax6"};